import React from 'react';
export function DarkQuoteSection() {
  return <section className="w-full bg-dark py-20 md:py-28 px-6 text-center" data-id="element-15">
      <div className="max-w-4xl mx-auto flex flex-col gap-10 md:gap-14" data-id="element-16">
        <p className="font-playfair text-2xl md:text-3xl lg:text-4xl text-white/80 italic font-light" data-id="element-17">
          "Algunas emociones que sientes… nunca fueron tuyas."
        </p>
        <p className="font-playfair text-2xl md:text-3xl lg:text-4xl text-warmgold italic font-light" data-id="element-18">
          "Quizás estás viviendo una historia… que no empezó contigo."
        </p>
        <p className="font-playfair text-3xl md:text-4xl lg:text-5xl text-terracotta italic font-medium leading-tight" data-id="element-19">
          "Lo que llamas autosabotaje… podría ser lealtad familiar invisible."
        </p>
      </div>
    </section>;
}